// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2oNem","title":"FrontImage_title__1AtmJ"};